var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Execute",
        visible: _vm.isOpen,
        width: "7.2rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c(
        "div",
        [
          _c("voteFromTo", {
            staticStyle: { "margin-bottom": "0.3rem" },
            attrs: { title: _vm.pageData.title, desc: _vm.pageData.desc },
            on: {
              "update:title": function ($event) {
                return _vm.$set(_vm.pageData, "title", $event)
              },
              "update:desc": function ($event) {
                return _vm.$set(_vm.pageData, "desc", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            staticClass: "common-btn-blue-sm",
            attrs: { label: "Submit" },
            on: { clickHandle: _vm.save },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }